import { google } from 'google-maps'

const OPTIONS: google.maps.MapOptions = {
  zoom: 15,
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  scrollwheel: false,
  disableDoubleClickZoom: true,
  gestureHandling: 'greedy',
  panControl: false,
  minZoom: 10,
  maxZoom: 17,

  styles: [
    // {
    //   stylers: [{ visibility: 'off' }],
    // },
    {
      featureType: 'poi',
      stylers: [{ visibility: 'off' }],
    },
  ],
  // styles: [
  //   {
  //     featureType: 'administrative.locality',
  //     elementType: 'geometry.stroke',
  //     stylers: [
  //       {
  //         // color: '#cbcbcb',
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'landscape.man_made',
  //     elementType: 'geometry.fill',
  //     stylers: [
  //       {
  //         lightness: 50,
  //       },
  //       {
  //         visibility: 'on',
  //       },
  //       {
  //         weight: 1,
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'landscape.man_made',
  //     elementType: 'geometry.stroke',
  //     stylers: [
  //       {
  //         color: '#f1f1f1',
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'landscape.man_made',
  //     elementType: 'labels.icon',
  //     stylers: [
  //       {
  //         color: '#000000',
  //       },
  //       {
  //         weight: 5,
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'poi',
  //     elementType: 'geometry.fill',
  //     stylers: [
  //       {
  //         color: '#8dffa4',
  //       },
  //       {
  //         saturation: -50,
  //       },
  //       {
  //         lightness: 25,
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'poi.business',
  //     stylers: [
  //       {
  //         visibility: 'off',
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'poi.park',
  //     elementType: 'labels.text',
  //     stylers: [
  //       {
  //         visibility: 'off',
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'road',
  //     elementType: 'geometry.fill',
  //     stylers: [
  //       {
  //         saturation: -70,
  //       },
  //       {
  //         weight: 5.5,
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'road',
  //     elementType: 'geometry.stroke',
  //     stylers: [
  //       {
  //         color: '#f1f1f1',
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'road.arterial',
  //     elementType: 'geometry.stroke',
  //     stylers: [
  //       {
  //         weight: 0.5,
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'road.highway',
  //     elementType: 'geometry.fill',
  //     stylers: [
  //       {
  //         color: '#f4ff97',
  //       },
  //       {
  //         saturation: -20,
  //       },
  //       {
  //         lightness: 25,
  //       },
  //     ],
  //   },
  //   {
  //     featureType: 'water',
  //     elementType: 'geometry.fill',
  //     stylers: [
  //       {
  //         color: '#9fc3ff',
  //       },
  //       {
  //         lightness: 30,
  //       },
  //       {
  //         visibility: 'on',
  //       },
  //     ],
  //   },
  // ],
}

export default OPTIONS
